import { pb } from './pocketbase';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const checkSessionCode = async (sessionCode, studentId, attendance) => {
  
  console.log("sessionCode", sessionCode)
  console.log("StudentId", studentId)
  console.log("Attendance", attendance)
  
  try {
    const response = await axios.post(`${API_BASE_URL}/api/check-session-code`, {
      sessionCode,
      studentId,
      attendance
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pb.authStore.token
      }
    });

    const result = response.data;
    
    if (response.status !== 200) {
      throw new Error(result.error || 'Erreur lors de la vérification du code');
    }

    return result;
  } catch (error) {
    console.error('Erreur lors de la vérification du code de session:', error);
    throw error;
  }
};


export const checkSessionQr = async (qrToken, studentId, attendance) => {
  
  console.log("qrToken", qrToken)
  console.log("StudentId", studentId)
  console.log("Attendance", attendance)
  
  try {
    const response = await axios.post(`${API_BASE_URL}/api/check-session-qr`, {
      qrCode: qrToken,
      studentId,
      attendance
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pb.authStore.token
      }
    });

    const result = response.data;
    
    if (response.status !== 200) {
      throw new Error(result.error || 'Erreur lors de la vérification du code');
    }

    return result;
  } catch (error) {
    console.error('Erreur lors de la vérification du code de session:', error);
    throw error;
  }
};


